/**
 * The tones a telephone keypad sends once a call is up.
 *
 * A switchboard that answers "marque la extensión" is listening for these, and
 * until the softphone could send them an agent in the browser had no way past
 * it: the call connected and stopped at the menu.
 */

/** The twelve keys of a telephone, in the order its pad draws them. */
export const DTMF_KEYS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "*",
  "0",
  "#",
] as const;

/**
 * The tone a key press stands for, or `null` when it is not one.
 *
 * `#` and `*` are a modifier away on most Spanish layouts — AltGr+3, which
 * Windows reports as Ctrl+Alt together, or Option+3 on a Mac — so a modifier
 * cannot mean "shortcut" for them. For a digit it does: Ctrl+1 is the
 * browser's tab, not the call's extension.
 */
export function dtmfKey(event: KeyboardEvent): string | null {
  const { key } = event;
  if (!/^[0-9*#]$/.test(key) || event.metaKey) return null;
  const modified = event.ctrlKey !== event.altKey;
  if (modified && /\d/.test(key)) return null;
  return key;
}
